import React, { useState } from "react";
import { useSwipeable } from "react-swipeable";
import "../styles/WebPageSlider.css";

const sites = [
  "https://www.ahuncycle.com/jeux/velo",
  "https://visionnairedrone.com",
  "https://ahuncycle.com",
  "https://poesieacademie.com",
  "https://climat-two.vercel.app",
];

const WebPageSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goTo = (index) => {
    const total = sites.length;
    setCurrentIndex((index + total) % total);
  };

  return (
    <div className="slider-container">

      {/* Flèche gauche */}
      <button className="nav-button left" onClick={() => goTo(currentIndex - 1)}>
        <svg className="arrow-icon" viewBox="0 0 24 24">
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </button>

      {/* Wrapper iframe + zones swipe */}
      <div className="iframe-wrapper">

        {/* Zone swipe gauche */}
        <div
          className="swipe-left"
          {...useSwipeable({
            onSwipedRight: () => goTo(currentIndex - 1),
            onSwipedLeft: () => {},
            preventScrollOnSwipe: true,
          })}
        ></div>

        {/* Zone swipe droite */}
        <div
          className="swipe-right"
          {...useSwipeable({
            onSwipedLeft: () => goTo(currentIndex + 1),
            onSwipedRight: () => {},
            preventScrollOnSwipe: true,
          })}
        ></div>

        {/* Iframe */}
        <iframe
          src={sites[currentIndex]}
          title={`site-${currentIndex}`}
          className="iframe"
        ></iframe>
      </div>

      {/* Flèche droite */}
      <button className="nav-button right" onClick={() => goTo(currentIndex + 1)}>
        <svg className="arrow-icon" viewBox="0 0 24 24">
          <path d="M9 6l6 6-6 6" />
        </svg>
      </button>
    </div>
  );
};

export default WebPageSlider;
